export const SHOW_TV_PASSWORD_TOOLTIP_TEXT = 'Mostrar senha'

export const HIDE_TV_PASSWORD_TOOLTIP_TEXT = 'Esconder senha'
